import React from 'react';
import { motion } from 'framer-motion';
import type { MetricItem } from '../../types/premium';
import './MetricsStrip.css';

interface MetricsStripProps {
  metrics: MetricItem[];
}

const MetricsStrip: React.FC<MetricsStripProps> = ({ metrics }) => (
  <section className="metrics-strip" aria-label="Key metrics">
    <div className="metrics-strip__grid">
      {metrics.map((metric, index) => (
        <motion.div
          key={metric.label}
          className="metrics-strip__item"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.08, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="metrics-strip__value">
            <span>{metric.value}</span>
            {metric.suffix ? <span className="metrics-strip__suffix">{metric.suffix}</span> : null}
          </div>
          <p className="metrics-strip__label">{metric.label}</p>
        </motion.div>
      ))}
    </div>
  </section>
);

export default MetricsStrip;
